import React from 'react';

const formatDate = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-');
    return `${d}.${m}.${y}`;
};

const AppIntro = ({ registration, values, handleChange, nextStep, focusedTitleRef }) => {
    const apt = registration?.apartment;
    const { parking, moveinDate, apartmentComments } = values;

    const availabilityDisplay = apt?.availableByAgreement
        ? 'Nach Vereinbarung'
        : formatDate(apt?.availabilityDate);

    return (
        <div>
			<h2 ref={focusedTitleRef} tabIndex={-1}>Wohnungsbewerbung</h2>

			{apt && (
                <section className="app-confirm__section mb-5">
                    <p className="fw-bold">{apt.title}</p>
                    <table className="app-confirm__table">
                        <tbody>
                            {apt.address && <tr><td className="app-confirm__label">Adresse</td><td className="fw-bold">{apt.address}{apt.zip ? `, ${apt.zip}` : ''}{apt.city ? ` ${apt.city}` : ''}</td></tr>}
                            {apt.numberOfRooms && <tr><td className="app-confirm__label">Zimmer</td><td className="fw-bold">{apt.numberOfRooms}</td></tr>}
                            {apt.surfaceArea && <tr><td className="app-confirm__label">Fläche</td><td className="fw-bold">{apt.surfaceArea} m²</td></tr>}
                            {apt.floor && <tr><td className="app-confirm__label">Etage</td><td className="fw-bold">{apt.floor}</td></tr>}
                            {apt.rentPerMonth && <tr><td className="app-confirm__label">Miete</td><td className="fw-bold">CHF {Number(apt.rentPerMonth).toLocaleString('de-CH')} / Monat</td></tr>}
                            {availabilityDisplay && <tr><td className="app-confirm__label">Verfügbar ab</td><td className="fw-bold">{availabilityDisplay}</td></tr>}
                        </tbody>
                    </table>
                </section>
            )}

            <div className="mb-4">
                <p className="form-label">Benötigen Sie einen Parkplatz?</p>
                {[['garage', 'Garage'], ['outdoors', 'Aussenparkplatz'], ['', 'Kein Parkplatz']].map(([val, label]) => (
                    <div className="form-check" key={val || 'none'}>
                        <input className="form-check-input" type="radio" id={`parking_${val || 'none'}`} name="parking" value={val} checked={parking === val} onChange={handleChange('parking')} />
                        <label className="form-check-label" htmlFor={`parking_${val || 'none'}`}>{label}</label>
                    </div>
                ))}
            </div>

            <div className="row mb-4">
                <div className="col-12 col-md-6">
                    <label className="form-label" htmlFor="moveinDate">Gewünschter Bezugstermin</label>
                    <input id="moveinDate" type="date" className="form-control" value={moveinDate} onChange={handleChange('moveinDate')} />
                </div>
            </div>

            <div className="mb-4">
                <label className="form-label" htmlFor="apartmentComments">Bemerkungen</label>
                <textarea id="apartmentComments" className="form-control" rows={4} value={apartmentComments} onChange={handleChange('apartmentComments')} maxLength={1000} />
            </div>

            <div className="d-flex justify-content-end mt-5">
                <button className="btn btn-secondary" onClick={nextStep}>Weiter</button>
            </div>
        </div>
    );
};

export default AppIntro;
